import axios from 'axios';

const syncStepEndpoints = ({ stepId, endpoints }) => {
  return axios.put(`conversations/builder/steps/${stepId}/endpoints/sync`, {
    ids: endpoints
  });
};

export { syncStepEndpoints };
